// extracted by mini-css-extract-plugin
export default {"styleHeader":"Header_styleHeader__VhvcD","headerImg":"Header_headerImg__Q2qkl"};